import { phTrack } from "../analytics/productAnalytics";
import { posthogBehaviorEvent } from "../analytics/posthogEvents";

export type BehaviorEvent =
  | "menu_open_desktop"
  | "menu_open_mobile"
  | "menu_navigate_desktop"
  | "menu_navigate_mobile"
  | "search_open"
  | "filters_open"
  | "filters_apply"
  | "sort_change"
  | "catalog_page_next"
  | "catalog_page_previous"
  | "catalog_grid_toggle"
  | "home_reviews_view"
  | "home_customers_view"
  | "home_customer_click"
  | "home_benefit_details_open"
  | "home_shape_select"
  | "home_collection_tab_select"
  | "newsletter_subscribe_success"
  | "pdp_gallery_engage"
  | "pdp_description_open"
  | "pdp_details_open"
  | "pdp_shipping_open"
  | "pdp_returns_open"
  | "pdp_size_guide_open";

export type BehaviorDetail =
  | "new_arrivals"
  | "best_sellers"
  | "sunglasses"
  | "eyeglasses"
  | "final_sale"
  | "free_shipping"
  | "buy_now_pay_later"
  | "glasses_sold"
  | "authentic"
  | "inventory"
  | "retail_set"
  | "internal_product"
  | "instagram"
  | "external_story"
  | "unspecified";

export const trackBehaviorEvent = (
  event: BehaviorEvent,
  detail?: BehaviorDetail
): void => {
  if (typeof window === "undefined") return;
  if (!window.vfConsent?.has("analytics")) return;
  if (!Array.isArray(window.dataLayer)) return;

  // Event names and optional details are deliberately finite. No free-form
  // text, search query, customer identifier, product prescription, or checkout
  // value is sent to Clarity.
  window.dataLayer.push({
    event,
    ...(detail ? { behavior_detail: detail } : {}),
  });

  // PostHog receives the same snake_case name and finite detail.
  try {
    const mapped = posthogBehaviorEvent(event, detail);
    if (mapped) phTrack(mapped.event, mapped.props);
  } catch {
    // Product analytics must never interrupt the storefront.
  }
};
